import { Dispatch, SetStateAction } from 'react';
import { ace_index } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { areObjectsDifferent } from '../../utils/compareObjects';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function NumCallsBetween({ query, setQuery, editable = false }: Props) {
  const state = getNumCalls(query);
  const filter =
    options.find((option) => !areObjectsDifferent(option.value, state)) ??
    options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setNumCalls(option.value))}
      stringify={(option) => option.label}
      value={filter}
      label="Number of calls"
      description="Filter applications by how many calls have been made (either answered or unanswered)"
      disabled={!editable}
    />
  );
}

const options: { label: string; value: Value }[] = [
  {
    label: 'All',
    value: undefined,
  },
  {
    label: '0 calls',
    value: {
      To: 1,
    },
  },
  {
    label: '0-2 calls',
    value: {
      To: 3,
    },
  },
  {
    label: '2+ calls',
    value: {
      From: 2,
    },
  },
  {
    label: '3+ calls',
    value: {
      From: 3,
    },
  },
];

function setNumCalls(range: Value): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    SummaryNumCalls: range,
  });
}

function getNumCalls(query: ace_index.FindInput) {
  return query.SummaryNumCalls;
}

type Value = ace_index.FindInput['SummaryNumCalls'];
